<template>
    <div>

    <revslider v-if=" getCategory == 'indice' && isSearch != true "></revslider>

  	<div class="container-fluid content">

      <!-- BUSCADOR AVANZADO -->
      <router-view></router-view>

      <div class="row">
        <!-- <pre>{{ getReloadContent }}</pre> -->
        <div v-if="isSearch" class="col-md-12">

          <div v-if="loading">
            <div class="col-md-12 center">
              <div class="loading"><img src="@/assets/img/loading.gif" alt=""></div>
            </div>
          </div>

          <template v-else>

            <h4><!--{{ $t('Búsqueda') }}:  --><span>{{ searchTerm }}</span> ( <span>{{ searchCount }}</span> )</h4>

            <div class="row filters">
              <div class="col-md-6">
                <ordenar-por-titulo></ordenar-por-titulo>
                <ordenar-por-precio></ordenar-por-precio>
                <ordenar-por-fecha></ordenar-por-fecha>
              </div>
              <div class="col-md-6 right">
                <resultados-por-pagina></resultados-por-pagina>
              </div>
            </div>

            <template v-if="datosBusqueda">
              <ficha-basica v-for="data in datosBusqueda" :datos="data" :key="data.id"
                :type.sync="modalType"
                :productID.sync="modalProductID"
                :show.sync="showModalFichaExtendida"
                :contenedor.sync="contenedor">
              </ficha-basica>
            </template>

            <!-- <div v-if="search_error" class="frm-error">{{ search_error_message }}</div> -->
            <div v-if="search_error" class="search-error">{{ search_error_message }}</div>

            <paginacion v-if="searchCount" :totalResults="searchCount"></paginacion>         

            <modal-ficha-extendida 
              :show.sync="showModalFichaExtendida"
              :type="modalType"
              :productID="modalProductID"
              :contenedor="contenedor">
            </modal-ficha-extendida>

          </template>

        </div>

        <div v-else class="col-md-12 indice">
          <template v-if="datosIndice">
            <contenedor v-for="data in datosIndice" :datos="data" :key="data.titulo"></contenedor>
          </template>
        </div>

      </div>
    </div>
  </div>

</template>

<i18n>
{
  "es": {
    "Más": "Más",
    "Búsqueda": "Búsqueda" 
  },
  "en": {
    
  },
  "ca": {
    "Más": "Més",
    "Búsqueda": "Cerca" 
  }
}
</i18n>

<script>
  import axios from 'axios';
  import FichaBasica from './FichaBasica.vue';
  import Paginacion from './Paginacion.vue';
  import ModalFichaExtendida from './ModalFichaExtendida.vue';
  import ResultadosPorPagina from './ResultadosPorPagina.vue';
  import OrdenarPorPrecio from './OrdenarPorPrecio.vue';
  import OrdenarPorTitulo from './OrdenarPorTitulo.vue';
  import OrdenarPorFecha from './OrdenarPorFecha.vue';
  import Contenedor from './Contenedor.vue';
  import Revslider from './Revslider.vue';

  import { mapGetters } from 'vuex';

	export default {
    components: { FichaBasica, Paginacion, ModalFichaExtendida, ResultadosPorPagina, OrdenarPorPrecio, OrdenarPorTitulo, OrdenarPorFecha, Contenedor, Revslider },
		data: () => {
			return {
        showModalFichaExtendida: false,
        modalType: "",
        modalProductID: 0,
        contenedor: '',
        loading: false,
        search_error: false,
        search_error_message: '',
        rawData:[]
        /*searchCount: 0*/
			}
		},
    created(){
      if(this.isSearch){
        this.cargarResultadoBusqueda();
      }else{
        this.cargarIndice();
      }
    },
    mounted(){
      //TEMP SHOW MODAL
      /*this.showModalFichaExtendida = true;
      this.modalType = 'C';
      this.modalProductID = 258879;*/
    },
    beforeUpdate(){
      //this.rawData = '';
      //console.log('beforUpdate');
    },
    beforeDestroy(){
      //console.log('beforeDestroy');
    },
    computed: {
      ...mapGetters(['getLocale', 'getApiUrl', 'getSearchTerms', 'isSearch', 'getReloadContent', 'getSelectionBus', 'getCategory']),
      /*...mapGetters(['getLocale', 'getApiUrl', 'getSearchTerms', 'isSearch', 'getReloadContent', 'getSearchResult']),
      datos: function(){ return (this.getSearchResult != '') ? this.getSearchResult.data.data : '' },
      searchCount: function(){ return (this.getSearchResult != '') ? this.getSearchResult.data.data.num_resultados : 0 },
      searchTerm: function(){ return (this.getSearchResult != '') ? this.getSearchResult.data.data.busqueda : '' },*/
      searchTerm: function(){ return (this.rawData != '') ? this.rawData.data.data.busqueda : '' },
      searchCount: function(){ return (this.rawData != '') ? this.rawData.data.data.num_resultados : 0 },
      datosBusqueda: function(){ return (this.rawData != '') ? this.rawData.data.data.resultados : '' },
      datosIndice: function(){ return (this.rawData != '') ? this.rawData.data.data : '' },
    },
    methods:{
      cargarResultadoBusqueda(){
        // CASO ESPECIAL Listados expandidos con filtro
        if( !this.getSearchTerms.query.expandido ){
          // QUERY EMPTY
          if( !(this.getSearchTerms.query == '') ){
            this.showLoading();
            axios.get( this.getApiUrl + this.getSearchTerms.idioma + '/' + this.getSearchTerms.categoria, {
                params: this.getSearchTerms.query
              })
            //axios.get('src/json/search-result-loggedIn.json')
            .then( (respuesta) =>{
              //this.$store.commit('setSearchResult', respuesta)
              this.rawData = respuesta;
              this.hideLoading();
              //console.log(respuesta); //this.getSearchTerms.query
              $('html,body').animate({
                  scrollTop: 0
              }, 500);
            })
            .catch( (error) =>{ 
              //this.$store.commit('setSearchResult', '') error.response.data.status + ' ' +
              this.rawData = '';
              this.search_error_message = error.response.data.msg;
              this.search_error = true;
              //console.log(JSON.stringify(error));
              this.hideLoading();              
            });
          }else{
            // NO SEARCH => INDEX
          }
        }
      },
      cargarIndice(){
        this.showLoading();
        axios.get(this.getApiUrl + this.getSearchTerms.idioma + '/' + this.getSearchTerms.categoria + '/indice')
          .then( (respuesta) =>{
            //this.$store.commit('setSearchResult', respuesta) ?cache
            this.rawData = respuesta;

            this.hideLoading();
            //console.log(respuesta); //this.getSearchTerms.query
            //console.log(JSON.stringify(respuesta));
          })
          .catch( (error) =>{ 
            //this.$store.commit('setSearchResult', '')
            this.rawData = '';
            this.search_error_message = error.response.data.status + ' ' + error.response.data.msg;
            this.search_error = true;
            //console.log(JSON.stringify(error));
            this.hideLoading();              
          });           
      },
      cancelImageloading(){
        //console.log('cancelImageloading');
        //cancel image downloads
        if(window.stop !== undefined){
          window.stop();
        }
        else if(document.execCommand !== undefined){
          document.execCommand("Stop", false);
        }
      },
      showLoading(){ this.loading = true; },
      hideLoading(){ this.loading = false; }
    },
    watch:{
      getSearchTerms: function() {    
        if(this.isSearch){
          this.rawData = '';
          this.cargarResultadoBusqueda();
        }else{
          this.rawData = '';
          this.cargarIndice();
        }
      },
      $route: function() {
        this.cancelImageloading();

        this.showModalFichaExtendida = false;
        this.search_error_message = '';
        this.search_error = false;
      },
      getReloadContent: function(newValue){
        if(newValue){
          if(this.isSearch){
            this.cargarResultadoBusqueda();
            //this.$store.commit('setReloadContent', false);
          }else{
            this.cargarIndice();
            //this.$store.commit('setReloadContent', false);
          }          
        }
      },
      getSelectionBus: function(){
        if(this.isSearch){
          //console.log(JSON.stringify(this.datosBusqueda))
          //console.log(JSON.stringify(this.getSelectionBus))
          let id = this.getSelectionBus.id;
          var obj = this.datosBusqueda.find(function (obj) { return obj.id === id; });
          obj.miseleccion = this.getSelectionBus.miseleccion;
        }  
      }
    }
  }
</script>
